import { VectorSquareIcon } from './VectorSquareIcon';

/**
 * author: Austin Andrews
 * id 039be9b8-08ad-11e4-bf19-842b2b6cfe1b
 * name vector-square
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-square.svg
 * tags
 * - Vector 
 * - Geographic Information System 
 */
export const MdiIcon = VectorSquareIcon;
export default MdiIcon